import { statusSchema, stringOptionalSchema, stringRequiredSchema } from "utils/validation/validationHelpers";
import { object, array } from 'yup';

const addContentSchema = object().shape({
    title: stringRequiredSchema,
    slug: stringRequiredSchema,
    status: statusSchema,
    seo_title: stringOptionalSchema,
    seo_keyword: stringOptionalSchema,
    seo_desc: stringOptionalSchema,
    cover_img: stringOptionalSchema,
    videos: array().optional(),
    description: stringRequiredSchema
});

export default addContentSchema;